export enum RejectedReasons {
  MissingStamp = 'missing_stamp',
  MissingSignature = 'missing_signature',
  MissingCopyOfBorrowerId = 'missing_copy_of_borrower_id',
  MissingPages = 'missing_pages',
  InconsistentSignatures = 'inconsistent_signatures',
  Other = 'other'
}
